module.exports = __webpack_public_path__ + "01_glasses_black.da8d23c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer4/01_glasses_black.png
// module id = nBFS
// module chunks = 0